import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const TendersContainer = styled(Box)(() => ({
    display: "flex",
    gap: "65px",
    justifyContent: "flex-start",
    padding: "15px",
    marginLeft:"10px",
  }));
  
  export const TendersCard = styled(Box)(({ theme }) => ({
    border: `2px solid ${theme.palette.jigsaw.green}`,
    borderRadius: "12px",
    width: "275px",
    height: "125px",
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.1)",
    position: "relative",
  }));
  
  export const TendersHeader = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    padding: "6px 12px",
    borderRadius: "6px",
    fontSize: "19px",
    fontWeight: "bold",
    width: "100%",
  }));
  
  export const TendersIconWrapper = styled(Box)(({ theme }) => ({
    width: "35px",
    height: "35px",
    margin: "4px",
    backgroundColor: theme.palette.jigsaw.green,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "8px",
    left: "8px",
  }));
  
  export const TendersIcon = styled("img")(() => ({
    width: "18px",
    height: "18px",
  }));
  
  export const TendersValue = styled(Box)(({ theme }) => ({
    fontSize: "28px",
    fontWeight: "bold",
    color: theme.palette.jigsaw.green,
    marginTop: "8px",
    alignSelf: "flex-start",
  }));